export default __webpack_public_path__ + "static/media/red-location-icon.59b63ce1.svg";